import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStats, getProducts } from '../services/api';

function Products() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const [statsData, productsData] = await Promise.all([
        getStats(),
        getProducts()
      ]);

      if (statsData.success) {
        setStats(statsData);
      } else {
        console.error('Failed to fetch stats:', statsData.error);
      }

      if (productsData.success) {
        setProducts(productsData.products);
      } else {
        console.error('Failed to fetch products:', productsData.error);
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  const handleJoinBatch = () => {
    navigate('/signup');
  };


  if (loading) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="text-center mb-5">
              <h1 className="display-5 fw-light text-muted">Our Products</h1>
              <p className="lead text-muted">Discover our premium offerings designed for your business</p>
            </div>
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body p-4">
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3">Loading store statistics...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="text-center mb-5">
            <h1 className="display-5 fw-light text-muted">Tired of Mid-Week Supply Runs, High Markups, and Late Deliveries?</h1>
            <p className="lead text-muted">We keep your salon stocked — reliably and at better pricing.</p>
            {stats && (
              <div className="alert alert-info mt-3">
                <strong>{stats.total_signups || 0} salons</strong> have joined us<br />
                Invite Nearby Salons. Unlock Network Pricing.
              </div>
            )}
          </div>
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  <span className="fs-5 fw-bold text-muted">Product</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="fs-5 fw-bold text-muted me-4">Price at Other Places</span>
                  <span className="fs-5 fw-bold text-muted">Our Price</span>
                </div>
              </div>
              <ul className="list-group list-group-flush">
                {products.filter(product => product.status === 'active').map((product, index) => (
                  <li key={product.id} className="list-group-item border-0 bg-transparent d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <span className="badge bg-primary rounded-circle p-2 me-3">{index + 1}</span>
                      <span className="fs-5 text-muted">{product.product_name}</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-secondary rounded-circle p-2 me-4">
                        ${parseFloat(product.price).toFixed(2)}
                      </span>
                      <span className="badge bg-success rounded-circle p-2">
                        ${parseFloat(product.you_pay).toFixed(2)}
                      </span>
                    </div>
                  </li>
                ))}
                {products.filter(product => product.status === 'active').length === 0 && (
                  <li className="list-group-item border-0 bg-transparent text-center">
                    <p className="text-muted">No active products available</p>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className="text-center">
            <button onClick={handleJoinBatch} className="btn btn-outline-primary btn-lg px-5 py-3 rounded-pill">
              Join Batch
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products;
